<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
                    </div>
                    <div class="mobile_container" v-loading="loading">
                        <ul>
                            <li v-for="(row, rowIndex) in tableData" :key="rowIndex" class="list_item" @click="handleClickToDetail(row)">
                                <p class="ellipsis">{{ row.customer_name }}</p>
                                <p>{{row.order_count}}单/¥{{ Number(row.total_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </PullContainer>
    </div>
</template>

<script>
import { TodayCustomerOrders } from "@/api";
import { pagination } from "@/mixins";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "OrderCustomers",
    components: {
        PullContainer,
        ReturnNavBar,
    },
    data() {
        return {
            loading: false,
            tableData: [],
        };
    },
    mixins: [pagination],
    created() {
        this.getTableData()
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.handleClickSearch();
            }
        },
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            TodayCustomerOrders(postData).then((res) => {
                if (res.code === 200) {
                    let { list, total } = res.data;
                    this.tableData = this.tableData.concat(list);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
            });
        },
        // 查看详情
        handleClickToDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id,
                    name: row.customer_name,
                },
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.mobile_container {
    padding: 10px 16px;
    ul {
        li {
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            padding: 10px;
            margin-bottom: 10px;
            p:nth-child(1) {
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(41, 144, 240, 1);
            }
            p:nth-child(2) {
                margin-top: 2px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(153, 153, 153, 1);
            }
            &:active {
                background-color: rgba(153, 153, 153, 0.04);
            }
        }
    }
}
</style>
